import { render, staticRenderFns } from "./NotifiedList.vue?vue&type=template&id=6c59b3d6"
import script from "./NotifiedList.vue?vue&type=script&lang=js"
export * from "./NotifiedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports